import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  showArcDialogEvent() {
    buryPoint.event({
      action: 'ARC入驻弹窗-出现弹窗',
      eventCategory: 'ARC入驻弹窗'
    });
  },
  clickArcDialogEvent() {
    buryPoint.event({
      action: 'ARC入驻弹窗-点击立即申请入住',
      eventCategory: 'ARC入驻弹窗'
    });
  },
  applicationArcPosEvent(flag) {
    const op = {
      1: 'Site详情页-接警服务-右上角ARC入驻申请',
      2: 'Site详情页-接警服务-ARC选择侧滑页-申请入驻',
      3: 'Company information-立即申请入驻'
    };
    buryPoint.event({
      action: 'ARC入住申请-0.0 申请入住-入口位置',
      eventCategory: 'ARC入住申请',
      eventLabel: op[flag]
    });
  },
  applicationArcAuthEvent(flag) {
    const op = {
      1: '已认证',
      2: '认证中',
      3: '未认证'
    };
    buryPoint.event({
      action: 'ARC入住申请-0.0 申请入住-认证状态',
      eventCategory: 'ARC入住申请',
      eventLabel: op[flag]
    });
  },
  checkVideo() {
    buryPoint.event({
      action: 'ARC入住申请-0.1 查看教学视频',
      eventCategory: 'ARC入住申请'
    });
  },
  checkDocument() {
    buryPoint.event({
      action: 'ARC入住申请-0.2 查看帮助文档',
      eventCategory: 'ARC入住申请'
    });
  },
  completeInfoEvent() {
    buryPoint.event({
      action: 'ARC入住申请-1.0 进入ARC完善信息页',
      eventCategory: 'ARC入住申请'
    });
  },
  applicationRequestEvent() {
    buryPoint.event({
      action: 'ARC入住申请-1.1 提交申请',
      eventCategory: 'ARC入住申请'
    });
  },
  inputApiKeyEvent() {
    buryPoint.event({
      action: 'ARC入住申请-1.2 已有API key',
      eventCategory: 'ARC入住申请'
    });
  },
  validateApiResEvent(flag) {
    const op = {
      1: '验证通过',
      2: '验证失败'
    };
    buryPoint.event({
      action: 'ARC入住申请-1.3 API key验证结果',
      eventCategory: 'ARC入住申请',
      eventLabel: op[flag]
    });
  },
  receiveApiKeyEvent() {
    buryPoint.event({
      action: 'ARC入住申请-2. 进入接收并配置ARC ID&Key页',
      eventCategory: 'ARC入住申请'
    });
  },
  resendApiKeyEvent() {
    buryPoint.event({
      action: 'ARC入住申请-2.1 重新发送ARC ID&Key',
      eventCategory: 'ARC入住申请'
    });
  },
  accessDeviceTestEvent() {
    buryPoint.event({
      action: 'ARC入住申请-3.0 接入设备测试',
      eventCategory: 'ARC入住申请'
    });
  },
  checkExampleEvent(flag) {
    const op = {
      1: '托管设备示例',
      2: '上传证明示例'
    };
    buryPoint.event({
      action: 'ARC入住申请-3.1 查看示例',
      eventCategory: 'ARC入住申请',
      eventLabel: op[flag]
    });
  },
  materialReviewEvent(flag) {
    const op = {
      1: '材料已提交审核，请耐心等待',
      2: '审核失败',
      3: '审核通过'
    };
    buryPoint.event({
      action: 'ARC入住申请-4.0 材料审核',
      eventCategory: 'ARC入住申请',
      eventLabel: op[flag]
    });
  }
};
